"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var filter_1 = require("../util/filter");
var data_helpers_1 = require("../util/data-helpers");
function matcher(word, item, textField) {
    if (!word) {
        return function () { return true; };
    }
    word = word.toLowerCase();
    return function (item) { return filter_1.default.startsWith(data_helpers_1.dataText(item, textField).toLowerCase(), word); };
}
exports.matcher = matcher;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/list/matcher.js
// module id = 202
// module chunks = 0 1 2 3 4 5 6